import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const useTaskPaneHeaderStyles = (hasPaneControls: boolean = false) => {
    const theme = useTheme();
    return createSxStyles({
        // A pane's own buttons sit in the corner of the pane, at the same inset as the rail's, rather than
        // on the header row: the row is two lines tall, so anything centred in it lands well below the top.
        paneControls: {
            position: "absolute",
            top: theme.spacing(1),
            right: theme.spacing(1.5),
        },
        // Keeps a long task name clear of those buttons, which are out of the flow and cannot push it.
        titleBlock: {
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "uppercase",
            width: "100%",
            paddingRight: hasPaneControls ? theme.spacing(9) : 0,
        },
        headerContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
        },
        seperator: {
            marginLeft: theme.spacing(0.5),
            marginRight: theme.spacing(0.5),
        },
        activityNavigation: {
            display: "flex",
            alignItems: "center",
            marginLeft: "-10px",
            paddingBottom: theme.spacing(1),
            color: theme.palette.primary.dark,
        },
        activityNavigationPosition: {
            fontSize: 12,
            fontWeight: "normal",
            textTransform: "none",
            whiteSpace: "nowrap",
            color: theme.palette.grey[600],
        },
    });
};
